<template>
  <section>
    <b-container fluid >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          class="text-center flex-column justify-content-center d-flex abouts-us-banner"
        >
            <b-container fluid >
              <b-row class="justify-content-center ">
                <img :src="bannerInfo.img" alt="">
                <b-col
                  cols="10"
                  md="8"
                  class="text-left flex-column justify-content-center d-flex abouts-us-slogan"
                >
                    <h1>{{bannerInfo.title}}</h1>
                    <h5>{{bannerInfo.subTitle}}</h5>
              
                </b-col>
              </b-row>
            </b-container>
       
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
  export default {
  props:{
      msgObj:Object,
  },
  data() {
    return {
      bannerInfo:{
        img:'',
        title:'',
        subTitle:''
      }
    };
  },
  watch: {},
  created() {
   this.bannerInfo = this.msgObj
  },
  mounted() {},
  methods: {
    
  },
};

</script>
<style>
  @import "../assets/css/sub-banner.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .abouts-us-banner img{
    height: calc(200px);
  }
  .abouts-us-slogan h1 {
    font-size: 22px;
  }
  .abouts-us-slogan h5 {
    font-size: 14px;
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {  
  .abouts-us-slogan h1 {
    font-size: 26px;
  }
  .abouts-us-slogan h5 {
    font-size: 18px;
  }
  
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .abouts-us-slogan h1 {
    font-size: 30px;
  }
  .abouts-us-slogan h5 {
    font-size: 20px;
  }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  .abouts-us-slogan h1 {
    font-size: 40px;
  }
  .abouts-us-slogan h5 {
    font-size: 30px;
  }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .abouts-us-slogan h1 {
    font-size: 52px;
  }
  .abouts-us-slogan h5 {
    font-size: 28px;
  }
}
</style>